import { Select } from '@wkda/styleguide';
import cx from 'classnames';
import { Field } from 'react-final-form';
import { useEffect } from 'react';
import { useCarleadCreationFormStore } from '../../Form/CarleadCreationFormStore';
import shallow from 'zustand/shallow';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectField = _ref => {
  let {
    input,
    props
  } = _ref;
  const {
    placeholder,
    className,
    mktSelector,
    ...rest
  } = props;
  const [value, setLabel] = useCarleadCreationFormStore(state => [state.values[input.name], state.setLabel], shallow);
  useEffect(() => {
    if (typeof value !== 'undefined') {
      var _find;
      const label = (_find = props.options.find(o => o.value === value)) === null || _find === void 0 ? void 0 : _find.label;
      setLabel(input.name, label);
    }
  }, [input.name, props.options, setLabel, value]);
  return /*#__PURE__*/_jsx(Select, {
    ...input,
    ...rest,
    placeholderOption: placeholder,
    className: cx('carlead-creation-field__control carlead-creation-field--select', className),
    mktSelector: mktSelector === null || mktSelector === void 0 ? void 0 : mktSelector.value
  });
};
export function selectFieldRenderer(props) {
  return /*#__PURE__*/_jsx(Field, {
    name: props.name,
    props: props,
    render: SelectField
  });
}